import React, { Component /*, createElement, Fragment */ } from 'react';

import MyEditor from './MyEditor/index.jsx';

export default class ReactRoot extends Component {
    render() {
        return <MyEditor />;
    }
}
